// extracted by mini-css-extract-plugin
export default {"approver":"Approvers_approver__yA2qP","add":"Approvers_add__2ofse"};